// extracted by mini-css-extract-plugin
export default {"userName":"index_userName__O-O5D"};